'use client';

import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import { LoggedInHome } from './components/logged-in-home';

interface NosLeadDashboardClientProps {
	session: Session;
}

function NosLeadDashboardWrapper({ session }: NosLeadDashboardClientProps) {
	return <LoggedInHome session={session} />;
}

// Main export that wraps with SessionProvider
export default function NosLeadDashboardClient({ session }: NosLeadDashboardClientProps) {
	return (
		<SessionProvider refetchOnWindowFocus={false} refetchInterval={0} session={session}>
			<NosLeadDashboardWrapper session={session} />
		</SessionProvider>
	);
}